// familiesData.ts - ACTUALIZADO con todas las familias

export interface Guest {
  name: string;
  isChild: boolean;
}

export interface FamilyData {
  familyName: string;
  guests: Guest[];
}

export const familiesData: Record<string, FamilyData> = {
  // FAMILIAS ANTERIORES
  'fam-garcia-silva': {
    familyName: 'García Silva',
    guests: [
      { name: 'Juan Carlos García Rivera', isChild: false },
      { name: 'Ana Elizabeth Silva Juárez', isChild: false },
      { name: 'Zaira Gacía Silva', isChild: false },
      { name: 'Juan Francisco García Silva', isChild: false },
      { name: 'Carol García Silva', isChild: false },
      { name: 'Ana Karla García Silva', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-garcia-rivera': {
    familyName: 'García Rivera',
    guests: [
      { name: 'Carmen Rivera Acosta', isChild: false },
      { name: 'Francisco García Cano', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-mendez-garcia': {
    familyName: 'Méndez García',
    guests: [
      { name: 'Rosalba', isChild: false },
      { name: 'Reyes', isChild: false },
      { name: 'Mariana', isChild: false },
      { name: 'Manuel', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-Mayra-Pablo': {
    familyName: 'Mayra y Pablo',
    guests: [
      { name: 'Mayra', isChild: false },
      { name: 'Pablo', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-guerrero-garcia': {
    familyName: 'Guerrero García',
    guests: [
      { name: 'Ofelia', isChild: false },
      { name: 'Chucho', isChild: false },
      { name: 'No podremos asistir', isChild: false }

    ]
  },
    'fam-nayeli-guerrero': {
    familyName: 'Guerrero García',
    guests: [
      { name: 'Nayeli', isChild: false },
      { name: 'Bella', isChild: true },
      { name: 'Valentina', isChild: true },
            { name: 'No podremos asistir', isChild: false }


    ]
  },
    'fam-guerrero-orozco': {
    familyName: 'Guerrero Orozco',
    guests: [
      { name: 'Marí', isChild: false },
      { name: 'Camila', isChild: false },
      { name: 'Emiliano', isChild: false },
      { name: 'Danna', isChild: true },
      { name: 'Romina', isChild: true },
      { name: 'Eithan', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },

  'fam-badillo-garcia': {
    familyName: 'Badillo García',
    guests: [
      { name: 'J Remedios Badillo Vargas', isChild: false },
      { name: 'Ma. Concepción Garcia Rivera', isChild: false },
      { name: 'Uriel Badillo García', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-badillo-gonzalez': {
    familyName: 'Badillo González',
    guests: [
      { name: 'Jovany', isChild: false },
      { name: 'Gaby', isChild: false },
      { name: 'Gael', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-de-jesus-garcia': {
    familyName: 'De Jesús García',
    guests: [
      { name: 'Juana', isChild: false },
      { name: 'J. Guadalupe', isChild: false },
      { name: 'Víctor', isChild: false },
      { name: 'Yamilet', isChild: false },
      { name: 'Oscar', isChild: false },
      { name: 'Huguito', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-leal-garcia': {
    familyName: 'Leal García',
    guests: [
      { name: 'Lorena', isChild: false },
      { name: 'Miguel', isChild: false },
      { name: 'Carlos', isChild: false },
      { name: 'Sofía', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-garcia': {
    familyName: 'García',
    guests: [
      { name: 'Javier', isChild: false },
      { name: 'Cindy', isChild: false },
      { name: 'Aranza', isChild: false },
      { name: 'Salma', isChild: false },
      { name: 'Fernando', isChild: false },
      { name: 'Mishel', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  //Familia materna
  'fam-silva-juarez': {
    familyName: 'Silva Juárez',
    guests: [
      { name: 'Lidia Juárez Martinez', isChild: false },
      { name: 'Juan Silva Rubio', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  
  'julian-juarez': {
    familyName: 'Juárez Martínez',
    guests: [
       { name: 'Julian Juárez Martínez ', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-silva-romero': {
    familyName: 'Silva Romero',
    guests: [
      { name: 'Isabel', isChild: false },
      { name: 'Jimena', isChild: false },
      { name: 'Hans', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-juarez-martinez': {
    familyName: 'Juárez Martínez',
    guests: [
      { name: 'Mamagela', isChild: false },
      { name: 'Paju', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-martinez-juarez': {
    familyName: 'Martínez Juárez',
    guests: [
      { name: 'Leticia', isChild: false },
      { name: 'Raymundo', isChild: false },
      { name: 'Vianey', isChild: false },
      { name: 'Sarai', isChild: false },
      { name: 'Andrés', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-juarez-rubio': {
    familyName: 'Juárez Rubio',
    guests: [
      { name: 'María', isChild: false },
      { name: 'Nemorio', isChild: false },
      { name: 'Guillermo', isChild: false },
      { name: 'Sergio', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-morales-juarez': {
    familyName: 'Morales Juárez',
    guests: [
      { name: 'Araceli', isChild: false },
      { name: 'Ramón', isChild: false },
      { name: 'Fernanda', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-juarez-lopez': {
    familyName: 'Juárez López',
    guests: [
      { name: 'Hugo', isChild: false },
      { name: 'Teresa', isChild: false },
      { name: 'Víctor', isChild: false },
      { name: 'Emmanuel', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fj-martinez-juarez': {
    familyName: 'Martínez Juárez',
    guests: [
      { name: 'Fátima', isChild: false },
      { name: 'José María', isChild: false },
      { name: 'Mateo', isChild: true },
      { name: 'Emiliano', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-jessica-silva': {
    familyName: 'Familia Silva',
    guests: [
      { name: 'Jessica', isChild: false },
      { name: 'Vanesa Arisbeth', isChild: false },
      { name: 'Johan Dariel', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-sanchez-sanchez': {
    familyName: 'Familia Sánchez Sánchez',
    guests: [
      { name: 'Norma', isChild: false },
      { name: 'Luis', isChild: false },
      { name: 'Itzel', isChild: false },
      { name: 'Aylin', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-hernandez-sanchez': {
    familyName: 'Familia Hernández Sánchez',
    guests: [
      { name: 'Concepción', isChild: false },
      { name: 'Edgar', isChild: false },
      { name: 'Said', isChild: false },
      { name: 'Naomi', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'vero': {
    familyName: 'Familia Silva',
    guests: [
      { name: 'Vero Silva', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-pueblito': {
    familyName: 'Familia Silva',
    guests: [
      { name: 'Pueblito Silva', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-aguilar-silva': {
    familyName: 'Aguilar Silva',
    guests: [
      { name: 'Basilia', isChild: false },
      { name: 'Federico', isChild: false },
      { name: 'Alma', isChild: false },
      { name: 'Cecilia', isChild: false },
      { name: 'Juan', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-alvarez-aguilar': {
    familyName: 'Alvarez Aguilar',
    guests: [
      { name: 'Lourdes', isChild: false },
      { name: 'Abraham', isChild: false },
      { name: 'Gabriel', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
      'fam-cimbron-aguilar': {
    familyName: 'Cimbrón Aguilar',
    guests: [
      { name: 'Dolores', isChild: false },
      { name: 'César', isChild: false },
      { name: 'Tamara', isChild: false },
      { name: 'Valentina', isChild: true },
      { name: 'César Jr.', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
          'fam-Camarillo-silva': {
    familyName: 'Camarillo Silva',
    guests: [
      { name: 'Laura', isChild: false },
      { name: 'Jóse Carlos', isChild: false },
      { name: 'Karla', isChild: false },
      { name: 'Aldo', isChild: false },

      { name: 'No podremos asistir', isChild: false }
    ]
  },
      'fam2-aguilar-silva': {
    familyName: 'Aguila Silva',
    guests: [
      { name: 'Carmen', isChild: false },
      { name: 'Emmanuel', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-lopez-juarez': {
    familyName: 'López Juárez',
    guests: [
      { name: 'Guadalupe', isChild: false },
      { name: 'Gustavo', isChild: false },
      { name: 'Gustavo Javier', isChild: false },
      { name: 'Arely', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },

  'fam-rodrigo-lopez-juarez': {
    familyName: 'Rodrigo López Juárez',
    guests: [
            { name: 'Rodrigo', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
  'fam-bailon-rivera': {
    familyName: 'Fam Bailon Rivera',
    guests: [
      { name: 'Eduvijes', isChild: false },
      { name: 'Marcos', isChild: false },
      { name: 'Emmanuel', isChild: false },
      { name: 'Valeria', isChild: false },
      { name: 'Samantha', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-ramirez-juarez': {
    familyName: 'Ramírez Juárez',
    guests: [
      { name: 'Blanca', isChild: false },
      { name: 'Marcos', isChild: false },
      { name: 'Gael', isChild: false },
      { name: 'Emir', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'dionisio': {
    familyName: 'Dionisio',
    guests: [
      { name: 'Juanita', isChild: false },
      { name: 'Karla', isChild: false },
      { name: 'Mayte', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-3': {
    familyName: 'Rivera',
    guests: [
      { name: 'Carmen', isChild: false },
      { name: 'José Cruz', isChild: false },
      { name: 'Blanca', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'david-yaneli': {
    familyName: 'David y Yaneli.',
    guests: [
      { name: 'David', isChild: false },
      { name: 'Yaneli', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },

  'fam-aguilar-silva-2': {
    familyName: 'Aguilar Silva',
    guests: [
      { name: 'Carmen', isChild: false },
      { name: 'Manuel', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },

  'fam-robles-silva': {
    familyName: 'Robles Silva',
    guests: [
      { name: 'Elena', isChild: false },
      { name: 'José', isChild: false },
      { name: 'Jesús', isChild: false },
      { name: 'Iván', isChild: false },
      { name: 'Dayana', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'carmen-yoselin': {
    familyName: 'Amiga',
    guests: [
      { name: 'Carmen Yoselin', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
   'kamila-apale': {
    familyName: 'Amiga',
    guests: [
      { name: 'Kamila Apale', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
     'fam-castillo-balderas': {
    familyName: 'Castillo Balderas',
    guests: [
      { name: 'Edson Castillo Balderas', isChild: false },
      { name: 'Jessica Belen Castillo Balderas', isChild: false },
      { name: 'Enrique Castillo', isChild: false },
      { name: 'Alma Delia Balderas', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
     'francisco-garcia': {
    familyName: 'Amigo',
    guests: [
      { name: 'Francisco García', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
 'fam-cruz-raminez': {
    familyName: 'Cruz Ramírez',
    guests: [
      { name: 'Juan Pablo Cruz Ramírez', isChild: false },
      { name: 'Paulina Ramírez', isChild: false },
      { name: 'Jorge Daen', isChild: false },
      { name: 'Zoé', isChild: true },
      { name: 'Matias', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
       'mariana': {
    familyName: 'Amiga',
    guests: [
      { name: 'Mariana', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
  'isabella': {
    familyName: 'Amiga',
    guests: [
      { name: 'Isabella', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
    'Sofía': {
    familyName: 'Amiga',
    guests: [
      { name: 'Sofía', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
  'arantxa': {
    familyName: 'Amiga',
    guests: [
      { name: 'Arantxa', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
   'fam-castrejon': {
    familyName: 'Castrejón',
    guests: [
      { name: 'Luis Argel', isChild: false },
      { name: 'Argelia Castrejon', isChild: false },
      { name: 'Antonio Fortino', isChild: false },
      { name: 'Alexander Basilio', isChild: false },
      { name: 'Sofía Fortino', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
     'fam-hermanas-monroy': {
    familyName: 'Hermanas Monroy',
    guests: [
      { name: 'Valentina', isChild: false },
      { name: 'Regina', isChild: false },
      { name: 'Mariana', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
     'fam-tenoch': {
    familyName: 'Martínez',
    guests: [
      { name: 'Tenoch', isChild: false },
      { name: 'Sandra Erika Mártinez', isChild: false },
      { name: 'Joaquín Hernández Álcantara', isChild: false },
      { name: 'Azul Arianna', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
       'fam-garcia-chavero': {
    familyName: 'García Chavero',
    guests: [
      { name: 'Francisco Javier', isChild: false },
      { name: 'Leticia Chavero Romero', isChild: false },
      { name: 'Eduardo Javier García Lázaro', isChild: false },
      { name: 'Regina Guadalupe García Chavero', isChild: true },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
       'hermanas-resendiz': {
    familyName: 'Hermanas Reséndiz',
    guests: [
      { name: 'Jazmín', isChild: false },
      { name: 'Lizeth', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'monse-aram': {
    familyName: 'Monse y Aram',
    guests: [
      { name: 'Monse', isChild: false },
      { name: 'Aram', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
      'Naomi': {
    familyName: 'Amiga',
    guests: [
      { name: 'Naomi', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
        'zoe': {
    familyName: 'Amiga',
    guests: [
      { name: 'Zoe', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
          'ximena': {
    familyName: 'Amiga',
    guests: [
      { name: 'Ximena', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
            'aide': {
    familyName: 'Amiga',
    guests: [
      { name: 'Aide', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
            'Laila': {
    familyName: 'Amiga',
    guests: [
      { name: 'Laila', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
    'valentina': {
    familyName: 'Amiga',
    guests: [
      { name: 'Valentina', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'iker': { 
  familyName: 'Amigo',
  guests: [
    { name: 'Íker', isChild: false },
    { name: 'No podré asistir', isChild: false }
  ]
},

  'francisco_javier': { 
    familyName: 'Amigo',
    guests: [
      { name: 'Francisco Javier', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'oswaldo': { 
    familyName: 'Amigo',
    guests: [
      { name: 'Oswaldo', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'victoria': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Victoria', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'evelyn': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Evelyn', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'natalia': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Natalia', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'hermanas-angie-monse': { 
    familyName: 'Hermanas Angie y Monse',
    guests: [
      { name: 'Angie', isChild: false },
            { name: 'Montse', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'yamilet': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Yamilet', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'lizet': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Lizet', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'allison': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Allison', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'melanie': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Melanie', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'rita': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Rita', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'esmeralda': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Esmeralda', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'hermanos-guzman': { 
    familyName: 'Hermanos Guzmán',
    guests: [
      { name: 'Angel', isChild: false },
      { name: 'Ariadne', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  'hermanos-bautista': { 
    familyName: 'Hermanos Bautista',
    guests: [
      { name: 'Jaquy', isChild: false },
      { name: 'Cesar', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
  'cami': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Cami', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
    'tios': { 
    familyName: 'Tios',
    guests: [
      { name: 'Tio', isChild: false },
      { name: 'Tia', isChild: false },
      { name: 'Mati', isChild: true },
      { name: 'No podré asistir', isChild: false }
    ]
  },
      'fam-guzman': { 
    familyName: 'Guzmán',
    guests: [
      { name: 'Dany', isChild: false },
      { name: 'Alfredo', isChild: false },
      { name: 'Rafa', isChild: true },
      { name: 'No podré asistir', isChild: false }
    ]
  },
        'fam-vazquez-hernandez': { 
    familyName: 'Vázquez Hernández',
    guests: [
      { name: 'Josefina', isChild: false },
      { name: 'Rodolfo', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'sra-miriam': { 
    familyName: 'Sra. Miriam',
    guests: [
      { name: 'Mirian', isChild: false },
      { name: 'Naomi', isChild: false },
       { name: 'Sarai', isChild: true },
      { name: 'No podré asistir', isChild: false }
    ]
  },
  'fam-rosales-hurtado': { 
    familyName: 'Rosales Hurtado',
    guests: [
      { name: 'Esmeralda', isChild: false },
      { name: 'Javier', isChild: false },
      { name: 'Jésus', isChild: false },
      { name: 'Genesis', isChild: false },
      { name: 'Adrian', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
    'fam-silverio-resendiz': { 
    familyName: 'Silverio Resendiz',
    guests: [
      { name: 'Liz', isChild: false },
      { name: 'Gustavo', isChild: false },
      { name: 'Santi', isChild: true },
      { name: 'No podré asistir', isChild: false }
    ]
  },
      'fam-olvera-gonzales': { 
    familyName: 'Olvera Gonzáles',
    guests: [
      { name: 'Liz', isChild: false },
      { name: 'Persona 2', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
        'david': { 
    familyName: 'Amigo',
    guests: [
      { name: 'David', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
          'gustavo': { 
    familyName: 'Amigo',
    guests: [
      { name: 'Gustavo', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
            'tioss': { 
    familyName: 'Tios',
    guests: [
      { name: 'Tio', isChild: false },
            { name: 'Tia', isChild: false },

      { name: 'No podré asistir', isChild: false }
    ]
  },
            'josue': { 
    familyName: 'Amigo',
    guests: [
      { name: 'Josué', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
        'Yad-Uba': { 
    familyName: 'Yadira y Ubaldo',
    guests: [
      { name: 'Yad', isChild: false },
      { name: 'Uba', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'fam-guzman-rodriguez': { 
    familyName: 'Guzmán Rodríguez',
    guests: [
      { name: 'Viri Guzmán Rodríguez', isChild: false },
      { name: 'María Lucia Rodríguez', isChild: false },
      { name: 'Gerardo Guzmán Espinosa', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
  'fam-sanchez-espinosa': { 
    familyName: 'Sánchez Espinosa',
    guests: [
      { name: 'Joana Sánchez Rodríguez', isChild: false },
      { name: 'Luis Espinosa', isChild: false },
      { name: 'Luna Sánchez Espinosa', isChild: true},
      { name: 'No podremos asistir', isChild: false }
    ]
  },
    'jaqueline': { 
    familyName: 'Jaqueline',
    guests: [
      { name: 'Jaqueline', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
      'mariana-hernandez': { 
    familyName: 'Mariana Hernández ',
    guests: [
      { name: 'Mar', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
      
          'fam-balderas': { 
    familyName: 'Familia Balderas',
    guests: [
      { name: 'Lorenzo', isChild: false },
      { name: 'Shamady', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
          'fam-resendiz-fuentes': { 
    familyName: 'Familia Reséndiz Fuentes',
    guests: [
      { name: 'Damián', isChild: false },
      { name: 'Karen ', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
          'fam-baustista-trejo': { 
    familyName: 'Familia Baustista Trejo',
    guests: [
      { name: 'Jair', isChild: false },
      { name: 'Paola ', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
          'fam-leija-navarro': { 
    familyName: 'Familia Leija Navarro',
    guests: [
      { name: 'Orlando', isChild: false },
      { name: 'Roxana', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
            'elia-ramirez': { 
    familyName: 'Elia Ramírez  ',
    guests: [
      { name: 'Elia', isChild: false },
      { name: 'Estrella', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
          'veroo': { 
    familyName: 'Vero',
    guests: [
      { name: 'Vero', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },
          'fam-salinas-gonzalez': { 
    familyName: 'Familia Salinas González',
    guests: [
      { name: 'Alejandro', isChild: false },
      { name: 'Laura', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
          'fam--rodriguez': { 
    familyName: 'Guzmán Rodríguez',
    guests: [
      { name: 'Hermana', isChild: false },
      { name: 'Luis', isChild: false },
      { name: 'Lunes', isChild: false },
      { name: 'No podremos asistir', isChild: false }
    ]
  },
        'emily': { 
    familyName: 'Amiga',
    guests: [
      { name: 'Emily', isChild: false },
      { name: 'No podré asistir', isChild: false }
    ]
  },

  };
